// TODO read this from the ENV
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { ProductList } from "./product_sets/product_list/product_list.js";
import { MobileCategorySelectionItems } from "./product_sets/mobile_category_selection_items/mobile_category_selection_items.js";
import { CategorySelectionItems } from "./product_sets/category_selection/category_selection_items.js";
import { ProductFilter } from "./product_sets/filter/product_filter.js";
import { ContinueButton } from "./product_sets/continue_button";
import { SummaryOverview } from "./product_sets/summary/summary_overview";

const getCdnUrl = (path) => `https://cdn.xeed.cz/${path}`;

class ProductSetsConfigurator extends Component {
  constructor(props) {
    super(props);
    this.changeTab = this.changeTab.bind(this);
    this.loadCategory = this.loadCategory.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.addToCategorySelection = this.addToCategorySelection.bind(this);
    this.handleFiltering = this.handleFiltering.bind(this);
    this.changeStepButton = this.changeStepButton.bind(this);
    this.setDefaultCategory = this.setDefaultCategory.bind(this);
    this.disableFiltering = this.disableFiltering.bind(this);
    this.resetItems = this.resetItems.bind(this);
    this.removeFromCategorySelection = this.removeFromCategorySelection.bind(
      this
    );
    this.handleStepChange = this.handleStepChange.bind(this);
    this.state = {
      items: JSON.parse(props.initialCategorySelections),
      itemIds: props.initialCategorySelectionIds,
      stepNumber: 1,
      stickCategorySelection: false,
      stickMobileCategorySelection: false,
      products: {
        ovens: [],
        hobs: [],
        dishwashers: [],
        microwaves: [],
        extractors: [],
        fridges: [],
      },
      filter: {
        ovens: {},
        hobs: {},
        dishwashers: {},
        microwaves: {},
        extractors: {},
        fridges: {},
      },
      filterItems: {
        ovens: [],
        hobs: [],
        dishwashers: [],
        microwaves: [],
        extractors: [],
        fridges: [],
      },
      brands: {
        ovens: [],
        hobs: [],
        dishwashers: [],
        microwaves: [],
        extractors: [],
        fridges: [],
      },
      categories: {
        ovens: [],
        hobs: [],
        dishwashers: [],
        microwaves: [],
        extractors: [],
        fridges: [],
      },
      productsCount: {
        ovens: 0,
        hobs: 0,
        dishwashers: 0,
        microwaves: 0,
        extractors: 0,
        fridges: 0,
      },
      loadedCategories: {
        ovens: false,
        hobs: false,
        dishwashers: false,
        microwaves: false,
        extractors: false,
        fridges: false,
      },
      productsPerPage: 20,
      paginationNumber: {
        ovens: 1,
        hobs: 1,
        dishwashers: 1,
        microwaves: 1,
        extractors: 1,
        fridges: 1,
      },
      loadingInProgress: false,
      filterInProgress: false,
      productAddingInProgress: false,
      startedUsage: false,
      selectedCategory: "",
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    if (this.state.stepNumber === 1) {
      return this.stepOne();
    } else {
      return this.stepTwo();
    }
  }

  priceSummary() {
    if (this.state.itemIds && this.state.itemIds.length > 2) {
      return (
        <div>
          <h4 style={{ color: "#4E4E4E", marginBottom: "-4px" }}>
            Běžná cena za tento set: {formatMoney(this.totalPrice())}
            <div>
              Vybraný set zvládneme doručit:{" "}
              <span style={{ color: "#008E05" }}>
                {calcDeliveryDateForProductSet(this.state.items)}
              </span>
            </div>
          </h4>

          <h4 style={{ color: "#008E05" }}>
            Cena setu po slevě: dozvíte se ihned po sestavení setu
          </h4>
        </div>
      );
    }
  }

  totalPrice() {
    let total = 0;

    this.state.items.map(function (item) {
      total = total + item[1].price * item[1].quantity;
    });

    return total;
  }

  discountedTotalPrice() {
    let total = 0;

    this.state.items.map(function (item) {
      total = total + item[1].price_for_set * item[1].quantity;
    });

    return total;
  }

  changeTab(tabName) {
    this.setState({ selectedCategory: tabName });

    if (!this.state.startedUsage) {
      window.history.pushState("", "", "/tvorba-setu/aplikace");
      trackPageview("/tvorba-setu/aplikace");
      this.setState({ startedUsage: true });
    }
  }

  addToCategorySelection(product, category) {
    this.setState({ productAddingInProgress: true });

    if (!this.state.startedUsage) {
      window.history.pushState("", "", "/tvorba-setu/aplikace");
      trackPageview("/tvorba-setu/aplikace");
      this.setState({ startedUsage: true });
    }

    $.post(
      "",
      { category: category, product_id: product.pr_id },
      function (data) {
        this.setState({ items: data.items, itemIds: data.ids });
        this.setState({ productAddingInProgress: false });
      }.bind(this)
    );
  }

  removeFromCategorySelection(product, category) {
    this.setState({ productAddingInProgress: true });

    $.post(
      "/tvorba-setu-spotrebicu/remove",
      { category: category, product_id: product.pr_id },
      function (data) {
        this.setState({ items: data.items, itemIds: data.ids });
        this.setState({ productAddingInProgress: false });

        if (
          this.state.itemIds &&
          this.state.itemIds.length < 3 &&
          this.state.stepNumber !== 1
        ) {
          this.setState({ stepNumber: 1 });
        }
      }.bind(this)
    );
  }

  stepOne() {
    if (
      !this.state.selectedCategory &&
      this.state.itemIds &&
      this.state.itemIds.length > 0
    ) {
      this.setDefaultCategory();
    }

    var headline;

    if (this.state.itemIds && this.state.itemIds.length > 2) {
      headline = "Ve vašem setu máte vybrány tyto spotřebiče";
    } else if (this.state.itemIds.length === 0) {
      headline = "Vyberte minimálně 3 spotřebiče";
    } else if (this.state.itemIds.length === 2) {
      headline = "Vyberte minimálně ještě 1 spotřebič";
    } else {
      headline =
        "Vyberte minimálně ještě " +
        (3 - this.state.itemIds.length) +
        " spotřebiče";
    }

    var mobileHeaderStyles = { top: -67, marginLeft: -2, marginRight: 2 };

    if (
      this.state.itemIds &&
      this.state.itemIds.length > 2 &&
      this.state.stickMobileCategorySelection &&
      !this.state.loadingInProgress
    ) {
      mobileHeaderStyles["top"] = -126;
      mobileHeaderStyles["marginLeft"] = -2;
      mobileHeaderStyles["marginRight"] = 2;
    }

    var introImage = this.state.loadingInProgress ? (
      <div
        id={"configurator-loading"}
        style={
          this.state.selectedCategory
            ? { textAlign: "center", marginBottom: 800, marginTop: 24 }
            : { textAlign: "center", marginTop: 24 }
        }
      >
        <div className="categories-box-loading loading-blinking">
          <div className="categories-loading">
            <div className="top-lines-container"></div>
            <div className="loading-line"></div>
            <div className="loading-line"></div>
            <div className="camera-container">
              <div className="camera-top"></div>
              <div className="camera-main">
                <div className="camera-circle_detail"></div>
                <div className="camera-circle_big">
                  <div className="camera-circle_small"></div>
                </div>
              </div>
            </div>
            <div className="small_lines_container">
              <div className="loading-line small"></div>
              <div className="loading-line small"></div>
            </div>
            <div className="bottom_lines">
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
            </div>
            <div className="big-line-container">
              <div className="loading-line big"></div>
            </div>
          </div>
          <div className="categories-loading">
            <div className="top-lines-container"></div>
            <div className="loading-line"></div>
            <div className="loading-line"></div>
            <div className="camera-container">
              <div className="camera-top"></div>
              <div className="camera-main">
                <div className="camera-circle_detail"></div>
                <div className="camera-circle_big">
                  <div className="camera-circle_small"></div>
                </div>
              </div>
            </div>
            <div className="small_lines_container">
              <div className="loading-line small"></div>
              <div className="loading-line small"></div>
            </div>
            <div className="bottom_lines">
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
            </div>
            <div className="big-line-container">
              <div className="loading-line big"></div>
            </div>
          </div>
          <div className="categories-loading">
            <div className="top-lines-container"></div>
            <div className="loading-line"></div>
            <div className="loading-line"></div>
            <div className="camera-container">
              <div className="camera-top"></div>
              <div className="camera-main">
                <div className="camera-circle_detail"></div>
                <div className="camera-circle_big">
                  <div className="camera-circle_small"></div>
                </div>
              </div>
            </div>
            <div className="small_lines_container">
              <div className="loading-line small"></div>
              <div className="loading-line small"></div>
            </div>
            <div className="bottom_lines">
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
            </div>
            <div className="big-line-container">
              <div className="loading-line big"></div>
            </div>
          </div>
          <div className="categories-loading">
            <div className="top-lines-container"></div>
            <div className="loading-line"></div>
            <div className="loading-line"></div>
            <div className="camera-container">
              <div className="camera-top"></div>
              <div className="camera-main">
                <div className="camera-circle_detail"></div>
                <div className="camera-circle_big">
                  <div className="camera-circle_small"></div>
                </div>
              </div>
            </div>
            <div className="small_lines_container">
              <div className="loading-line small"></div>
              <div className="loading-line small"></div>
            </div>
            <div className="bottom_lines">
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
              <div className="loading-line normal"></div>
            </div>
            <div className="big-line-container">
              <div className="loading-line big"></div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div style={{ textAlign: "center", marginTop: 24, marginBottom: 250 }}>
        <img
          style={
            this.state.stickCategorySelection
              ? { marginTop: 212, maxWidth: "100%" }
              : { maxWidth: "100%" }
          }
          src="/configurator.gif"
        />
      </div>
    );

    return (
      <div className="step-1">
        <div dangerouslySetInnerHTML={{ __html: this.props.introCopyHtml }} />

        <div style={{ textAlign: "center", marginBottom: 35 }}></div>
        <div className={"headlines-container"} style={{ minHeight: 36 }}>
          <h2
            style={{
              marginBottom: 15,
              lineHeight: 1,
              width: "50%",
              float: "left",
            }}
            id="step-1-headline"
          >
            {headline}
          </h2>

          {this.state.itemIds && this.state.itemIds.length < 3 ? (
            <h3
              className={"test"}
              style={{
                color: "gray",
                fontSize: 19,
                width: "50%",
                float: "right",
                paddingTop: 5,
                textAlign: "right",
              }}
            >
              <div>
                Vybraný set zvládneme doručit:{" "}
                <span style={{ color: "#008E05" }}>
                  dozvíte se po sestavení setu
                </span>
              </div>
            </h3>
          ) : null}

          {this.priceSummary()}
        </div>
        <div
          className={
            this.state.stickMobileCategorySelection &&
            !this.state.loadingInProgress
              ? "fix-mobile-header"
              : null
          }
          style={mobileHeaderStyles}
        >
          <MobileCategorySelectionItems
            items={this.state.items}
            selectedCategory={this.state.selectedCategory}
            changeTab={this.changeTab}
            loadCategory={this.loadCategory}
            removeFromCategorySelection={this.removeFromCategorySelection}
            removeImageUrl={this.props.removeImageUrl}
            loadingInProgress={this.state.loadingInProgress}
            handleGoOnFilter={this.handleGoOnFilter}
          />
        </div>

        <div
          className={
            this.state.stickCategorySelection && !this.state.loadingInProgress
              ? "fix-header"
              : null
          }
        >
          <CategorySelectionItems
            items={this.state.items}
            selectedCategory={this.state.selectedCategory}
            changeTab={this.changeTab}
            loadCategory={this.loadCategory}
            removeFromCategorySelection={this.removeFromCategorySelection}
            removeImageUrl={this.props.removeImageUrl}
            loadingInProgress={this.state.loadingInProgress}
          />

          {this.state.selectedCategory && !this.state.loadingInProgress ? (
            <ProductFilter
              filterItems={this.state.filterItems[this.state.selectedCategory]}
              filter={this.handleFiltering}
              activeFilters={this.state.filter[this.state.selectedCategory]}
              filterInProgress={this.state.filterInProgress}
              stickCategorySelection={this.state.stickCategorySelection}
              filteredProductsCount={this.filteredProductsCount()}
              productsCount={
                this.state.productsCount[this.state.selectedCategory]
              }
              disableFiltering={this.disableFiltering}
              brands={this.state.brands[this.state.selectedCategory]}
              categories={this.state.categories[this.state.selectedCategory]}
            />
          ) : null}
        </div>

        {this.state.selectedCategory && !this.state.loadingInProgress ? (
          <ProductList
            products={
              this.state.selectedCategory && this.state.products
                ? this.state.products[this.state.selectedCategory].slice(
                    0,
                    this.state.paginationNumber[this.state.selectedCategory] *
                      this.state.productsPerPage
                  )
                : []
            }
            category={this.state.selectedCategory}
            selectedCategoryItemsIds={this.state.itemIds}
            addToCategorySelection={this.addToCategorySelection}
            removeFromCategorySelection={this.removeFromCategorySelection}
            removeImageUrl={this.props.removeImageUrl}
            productAddingInProgress={this.state.productAddingInProgress}
            stickCategorySelection={this.state.stickCategorySelection}
          />
        ) : (
          introImage
        )}

        {this.showMoreButton()}

        {this.state.selectedCategory &&
        this.state.itemIds &&
        this.state.itemIds.length > 2
          ? this.changeStepButton()
          : null}
      </div>
    );
  }

  stepTwo() {
    return (
      <div className="step-2" style={{ marginLeft: 24 }}>
        <div dangerouslySetInnerHTML={{ __html: this.props.stepTwoCopyHtml }} />

        <SummaryOverview
          items={this.state.items}
          handleQuantityChange={this.handleQuantityChange}
          totalPrice={this.totalPrice()}
          stepChange={this.handleStepChange}
          removeFromCategorySelection={this.removeFromCategorySelection}
          removeImageUrl={this.props.removeImageUrl}
          changeStepButton={this.changeStepButton}
          discountedTotalPrice={this.discountedTotalPrice()}
          totalDiscount={formatMoney(
            this.totalPrice() - this.discountedTotalPrice()
          )}
        />
      </div>
    );
  }

  stepThree() {
    return (
      <div className="step-3">
        <div
          dangerouslySetInnerHTML={{ __html: this.props.finalStepCopyHtml }}
        />
      </div>
    );
  }

  showMoreButton() {
    var endOfPagination = this.state.selectedCategory
      ? this.state.products[this.state.selectedCategory].slice(
          0,
          this.state.paginationNumber[this.state.selectedCategory] *
            this.state.productsPerPage
        ).length == this.state.products[this.state.selectedCategory].length
      : true;

    if (endOfPagination) return null;

    return (
      <div style={{ textAlign: "center", display: "" }}>
        <div
          className="button button-smaller"
          onClick={() => this.handlePagination()}
        >
          Zobrazit více
        </div>
      </div>
    );
  }

  changeStepButton() {
    return (
      <ContinueButton
        stepNumber={this.state.stepNumber}
        stepChange={this.handleStepChange}
        resetItems={this.resetItems}
        itemsCount={this.state.itemIds.length}
        stickCategorySelection={this.state.stickCategorySelection}
        stickButton={this.state.stickButton}
      />
    );
  }

  resetItems() {
    Cookies.set("product_set_id", null);

    this.setState({
      items: this.props.initialCategorySelections,
      itemIds: [],
      stickCategorySelection: false,
    });
  }

  handleStepChange(step, token) {
    if (step === 1) {
      window.history.pushState("", "", "/tvorba-setu-spotrebicu");
      trackPageview("/tvorba-setu-spotrebicu");
      setTimeout(function () {
        window.scrollTo(0, 640);
      }, 2);
    } else if (step === 2) {
      window.history.pushState("", "", "/tvorba-setu/prehled");
      trackPageview("/tvorba-setu/prehled");
      window.scrollTo(0, 0);
    }

    this.setState({ stepNumber: step });
  }

  handlePagination() {
    var pagination = this.state.paginationNumber;

    pagination[this.state.selectedCategory] =
      pagination[this.state.selectedCategory] + 1;
    this.setState({ paginationNumber: pagination });
  }

  handleScroll() {
    var $categorySelectionTop = $(".headlines-container")[0];
    if ($categorySelectionTop === undefined) return;

    var scrollOffset = $categorySelectionTop.getBoundingClientRect().bottom;

    if (scrollOffset <= 14 && this.state.selectedCategory) {
      this.setState({
        stickMobileCategorySelection: true,
      });

      if (this.state.products[this.state.selectedCategory].length > 4) {
        this.setState({
          stickCategorySelection: true,
        });
      }
    } else if (scrollOffset > 14 && this.state.selectedCategory) {
      this.setState({
        stickCategorySelection: false,
      });
    }
  }

  handleFiltering(property, value) {
    this.setState({ filterInProgress: true });

    if (!this.state.startedUsage) {
      window.history.pushState("", "", "/tvorba-setu/aplikace");
      trackPageview("/tvorba-setu/aplikace");
      this.setState({ startedUsage: true });
    }

    var productsForTab = this.state.products;
    var filtration = this.state.filter;

    if (filtration[this.state.selectedCategory][property] === undefined) {
      filtration[this.state.selectedCategory][property] = value;
    } else if (filtration[this.state.selectedCategory][property] === value) {
      filtration[this.state.selectedCategory][property] = undefined;
    } else {
      filtration[this.state.selectedCategory][property] = value;
    }

    this.setState({ filter: filtration });

    $.post(
      "/tvorba-setu-spotrebicu/filter",
      {
        tab: this.state.selectedCategory,
        filter: filtration[this.state.selectedCategory],
      },
      function (data) {
        productsForTab[this.state.selectedCategory] = data.filtered_products;

        this.setState({ products: productsForTab });
        this.setState({ filterInProgress: false });
      }.bind(this)
    );
  }

  disableFiltering() {
    this.setState({ filterInProgress: true });

    var filtration = this.state.filter;
    var productsForTab = this.state.products;

    filtration[this.state.selectedCategory] = {};

    this.setState({ filter: filtration });

    $.post(
      "/tvorba-setu-spotrebicu/filter",
      {
        tab: this.state.selectedCategory,
        filter: filtration[this.state.selectedCategory],
      },
      function (data) {
        productsForTab[this.state.selectedCategory] = data.filtered_products;

        this.setState({ products: productsForTab });
        this.setState({ filterInProgress: false });
      }.bind(this)
    );
  }

  filteredProductsCount() {
    return this.state.selectedCategory
      ? Object.keys(this.state.products[this.state.selectedCategory]).length
      : 0;
  }

  setDefaultCategory() {
    let category = "ovens";

    this.state.items.forEach((item) => {
      if (item[1].pr_id !== undefined) {
        category = item[0];
      }
    });

    this.loadCategory(category);

    this.setState({ selectedCategory: category });
  }

  handleQuantityChange(category, quantity) {
    var modifiedItems = [].concat(state.items);

    modifiedItems.map((oldItem) => {
      if (oldItem[0] === category) {
        oldItem[1].quantity = quantity;
      }
    });

    this.setState({ items: modifiedItems });
  }

  loadCategory(category) {
    if (this.state.loadedCategories[category] === false) {
      this.setState({ loadingInProgress: true });

      $.post(
        "/tvorba-setu-spotrebicu/load_category",
        { category: category },
        function (data) {
          var modifiedFilterItems = this.state.filterItems;
          var modifiedBrands = this.state.brands;
          var modifiedCategories = this.state.categories;
          var modifiedLoadedCategories = this.state.loadedCategories;
          var modifiedProducts = this.state.products;
          var modifiedProductsCount = this.state.productsCount;

          modifiedFilterItems[data.category] = data.filter_items;
          modifiedBrands[data.category] = data.brands;
          modifiedCategories[data.category] = data.categories;
          modifiedLoadedCategories[data.category] = true;
          modifiedProducts[data.category] = data.all_products;
          modifiedProductsCount[data.category] = data.all_products.length;

          this.setState({ filterItems: modifiedFilterItems });
          this.setState({ brands: modifiedBrands });
          this.setState({ categories: modifiedCategories });
          this.setState({ categories: modifiedLoadedCategories });
          this.setState({ products: modifiedProducts });
          this.setState({ productsCount: modifiedProductsCount });

          this.setState({ loadingInProgress: false });
        }.bind(this)
      );
    }
  }

  handleGoOnFilter() {
    this.setState({ stickMobileCategorySelection: false });

    $("html, body").animate({
      scrollTop: $(".category-selection-top-position").offset().top + 15,
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const configuratorRoot = document.querySelector("#product-set-configurator");

  const initialCategorySelections =
    configuratorRoot.dataset.initialcategoryselections;
  const initialCategorySelectionIds =
    configuratorRoot.dataset.initialcategoryselectionids;
  const removeImageUrl = configuratorRoot.dataset.removeimageurl;
  const introCopyHtml = configuratorRoot.dataset.introcopyhtml;
  const stepTwoCopyHtml = configuratorRoot.dataset.steptwocopyhtml;
  const finalStepCopyHtml = configuratorRoot.dataset.finalstepcopyhtml;

  ReactDOM.render(
    <ProductSetsConfigurator
      initialCategorySelections={initialCategorySelections}
      initialCategorySelectionIds={initialCategorySelectionIds}
      removeImageUrl={removeImageUrl}
      introCopyHtml={introCopyHtml}
      stepTwoCopyHtml={stepTwoCopyHtml}
      finalStepCopyHtml={finalStepCopyHtml}
    />,
    document.getElementById("product-set-configurator")
  );
});
